<result
  type="success"
  [title]="title"
  description="激活邮件已发送到你的邮箱中，邮件有效期为24小时。请及时登录邮箱，点击邮件中的链接激活帐户。"
>
  <ng-template #title>
    <div class="title" style="font-size: 20px">你的账户：{{ email }} 注册成功</div>
  </ng-template>
  <button (click)="msg.success('email')" nz-button nzSize="large" [nzType]="'primary'">查看邮箱</button>
  <button routerLink="/" nz-button nzSize="large">返回首页</button>
</result>
